import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RanchCreateFertilizerDialog } from '../dialogs/fertilizer-dialog';
import { IRanchCreateFertilizerForm } from '../../ranch-settings/modals/fertilizer/interfaces';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-fertilizers-step',
	templateUrl: 'step-fertilizers.html',
	styleUrls: ['../ranch-create.scss']
})

export class RanchCreateFertilizersStepComponent {
	@Input()
	public form: FormArray;

	@Input()
	public subscriptions$: Subject<boolean>;

	@Output()
	public nextStep: EventEmitter<number> = new EventEmitter<number>();

	@Output()
	public onBack: EventEmitter<void> = new EventEmitter<void>();

	@Output()
	public onCancel: EventEmitter<void> = new EventEmitter<void>();

	public get fertilizerControls(): AbstractControl[] {
		if (!this.form) {
			return [];
		}

		return this.form.controls;
	}

	constructor(
		private _dialog: MatDialog,
		private _fb: FormBuilder
	) { }

	public back(): void {
		this.onBack.emit();
	}

	public cancel(): void {
		this.onCancel.emit();
	}

	public deleteFertilizer(index: number, event?: MouseEvent): void {
		if (event) {
			event.stopPropagation();
		}

		this.form.removeAt(index);
		this.form.markAsDirty();
	}

	public next(): void {
		this.form.markAllAsTouched();
		this.form.updateValueAndValidity();

		if (!this.form.valid) {
			return;
		}

		this.nextStep.emit(4);
	}

	public openAddFertilizerDialog(): void {
		this._dialog.open(RanchCreateFertilizerDialog, {
			width: '880px',
			disableClose: true,
			data: {
				selectedFertilizerIds: this._getSelectedFertilizerIds()
			}
		}).afterClosed().pipe(takeUntil(this.subscriptions$)).subscribe((fertilizers: IRanchCreateFertilizerForm[]) => {
			if (!fertilizers || fertilizers.length === 0) {
				return;
			}

			for (let fertilizer of fertilizers) {
				this.form.push(this._initializeForm(fertilizer));
			}

			this.form.markAsDirty();
		});
	}

	private _initializeForm(fertilizer: IRanchCreateFertilizerForm): FormGroup {
		return this._fb.group({
			Id: [fertilizer.Id],
			Name: [fertilizer.Name, Validators.required],
			FormulationTypeId: [fertilizer.FormulationTypeId],
			FormulationType: [fertilizer.FormulationType],
			PoundsPerGallon: [fertilizer.PoundsPerGallon],
			PercentageN: [fertilizer.PercentageN],
			Nutrients: [fertilizer.Nutrients],
			IsCustom: [fertilizer.IsCustom, Validators.required]
		});
	}

	private _getSelectedFertilizerIds(): number[] {
		return this.form.controls
			.map((control) => control.value as IRanchCreateFertilizerForm)
			.filter((fertilizer) => !fertilizer.IsCustom && fertilizer.Id)
			.map((fertilizer) => fertilizer.Id);
	}
}
